class FaqSection extends HTMLElement {
  constructor() {
    super();

    this._onItemClick = this.updateActiveContent.bind(this);
    this._onCategoryClick = this.updateActiveCategory.bind(this);
    this._initialized = false;
  }

  connectedCallback() {
    if (this._initialized) return;

    this._initialized = true;

    if (this.dataset.parentId) {
      this.mergeComponent(this.dataset.parentId);
    } else {
      this.registerEvents();
    }
  }

  registerEvents = () => {
    this.querySelectorAll('.faq-item:has(+ .faq-content)').forEach((element) => {
      element.removeEventListener('click', this._onItemClick);
      element.addEventListener('click', this._onItemClick);
    });

    this.querySelectorAll(
      '.faq-item:not(:has(+ .faq-content)):not([data-link])'
    ).forEach((element) => {
      element.removeEventListener('click', this._onCategoryClick);
      element.addEventListener('click', this._onCategoryClick);
    });
  };

  isMobile = () => {
    return window.matchMedia('(max-width: 749px)').matches;
  };

  updateActiveContent = (event) => {
    event.preventDefault();

    const clickedItem = event.currentTarget;
    const target = clickedItem.dataset.target;

    if (!target) {
      console.warn('FAQ itemにdata-targetが設定されていません。', clickedItem);
      return;
    }

    if (!this.isMobile()) {
      this.querySelectorAll('.faq-content.active').forEach((element) => {
        element.classList.remove('active');
      });

      this.querySelectorAll(
        '.faq-item:has(+ .faq-content).active'
      ).forEach((element) => {
        element.classList.remove('active');
      });
    }

    clickedItem.classList.toggle('active');

    this.querySelectorAll(
      `.faq__maincontent .faq-content[data-id="${CSS.escape(target)}"]`
    ).forEach((element) => {
      element.classList.toggle('active');
    });
  };

  updateActiveCategory = (event) => {
    event.preventDefault();
    event.currentTarget.classList.toggle('active');
  };

  mergeComponent = async (id) => {
    const parentComponent = document.querySelector(`#${CSS.escape(id)}`);

    if (!parentComponent) {
      console.warn(`親FAQセクション「#${id}」が見つかりません。`);
      return;
    }

    this.querySelectorAll(
      '.faq__sidemenu > .shopify-block > .faq-item'
    ).forEach((element) => {
      const targetComponent = parentComponent.querySelector(
        `.faq__sidemenu .faq-item[data-id="${CSS.escape(element.dataset.id || '')}"]`
      );

      const targetContentComponent =
        parentComponent.querySelector('.faq__maincontent');

      if (targetComponent) {
        element.parentElement
          .querySelectorAll(':scope > .shopify-block > .faq-item')
          .forEach((childItem) => {
            const childTarget = parentComponent.querySelector(
              `.faq__sidemenu .faq-item[data-id="${CSS.escape(
                childItem.dataset.id || ''
              )}"]`
            );

            if (childTarget) {
              childItem.parentElement
                .querySelectorAll(':scope > .shopify-block')
                .forEach((block) => {
                  const link = block.querySelector(':scope > a');
                  const contentTarget = link?.dataset.target;

                  if (contentTarget) {
                    const content = this.querySelector(
                      `.faq__maincontent .faq-content[data-id="${CSS.escape(
                        contentTarget
                      )}"]`
                    );

                    if (content) {
                      targetContentComponent?.insertAdjacentElement(
                        'beforeend',
                        content
                      );
                    }
                  }

                  childTarget.parentElement.insertAdjacentElement(
                    'beforeend',
                    block
                  );
                });
            } else {
              targetComponent.parentElement.insertAdjacentElement(
                'beforeend',
                childItem.parentElement
              );

              const contentTarget = childItem.dataset.target;

              if (contentTarget) {
                const content = this.querySelector(
                  `.faq__maincontent .faq-content[data-id="${CSS.escape(
                    contentTarget
                  )}"]`
                );

                if (content) {
                  targetContentComponent?.insertAdjacentElement(
                    'beforeend',
                    content
                  );
                }
              }
            }
          });
      } else {
        parentComponent
          .querySelector('.faq__sidemenu')
          ?.appendChild(element.parentElement);
      }
    });

    const actualParent =
      parentComponent.matches('faq-section')
        ? parentComponent
        : parentComponent.querySelector('faq-section');

    actualParent?.registerEvents();

    this.remove();
  };
}

if (!customElements.get('faq-section')) {
  customElements.define('faq-section', FaqSection);
}